import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectBrainId } from '@/redux/session/selectors';

/**
 * Returns brainId from URL params, falling back to Redux state.
 *
 * On /:slug/ai-agents/:brainId/* pages the URL is the source of truth: Redux is synced
 * from the URL one effect pass later (AIAgentRouter), so reading Redux directly yields
 * the PREVIOUS brain during in-app navigation between agents.
 */
export const useBrainId = (): string | null => {
  const { brainId: brainIdFromUrl } = useParams<{ brainId: string }>();
  const brainIdFromRedux = useSelector(selectBrainId);

  return brainIdFromUrl || brainIdFromRedux;
};
